export enum DataResolutionEnum {
  FIFTEEN_MINUTES = '15min',
  ONE_HOUR = 'hour',
  ONE_DAY = 'day',
  ONE_WEEK = 'week',
  ONE_MONTH = 'month',
  ONE_YEAR = 'year',
}
